export default {
  STARTS_AT: "Start Date",
  ENDS_AT: "End Date",
  COUNTER_SALES: "Counter Sales",
  BILLING: "Billing",
  DISTRIBUTOR_SALES: "Distributor Sales",
  COUNTER_PURCHASE: "Counter Purchase",
  STATIONERY: "Stationery",
  CLEANING_AND_DISPOSABLE_PRODUCTS: "Cleaning and Disposable Products",
  OTHERS: "Others",
  MAINTENANCE: "Maintenance",
  DISTRIBUTOR: "Distributor",
  WAGES: "Wages",
  RENT: "Rent",
  DISCOUNT: "Discount",
  FIXED_AMOUNT: "Fixed Amount",
  WITH_TAXES: "With Taxes",
  WITHOUT_TAXES: "Without Taxes",
  NO_TAXES: "No Taxes",
  WEEKLY_REPORTS_LIST: "Weekly Reports List",
  ADD_WEEKLY_REPORT: "Add Weekly Report",
  WEEKLY_REPORT_ADDED: "Weekly Report Added",
  EDIT_WEEKLY_REPORT: "Edit Weekly Report",
  WEEKLY_REPORT_UPDATED: "Weekly Report Updated",
  DELETE_THIS_WEEKLY_REPORT: "Delete this Weekly Report?",
  WEEKLY_REPORT_DELETED: "Weekly Report Deleted",
  SALES: "Sales",
  TITLE: "Weekly Reports",
  CREATE_REPORT: "Create Report",
  REPORT_CREATED_SUCCESSFULLY: "Weekly Report Created Successfully",
  REQUIRE_PREVIOUS_WEEK_REPORT: "Previous week report is required",
  NO_WAREHOUSES_FOUND: "No warehouses found for this establishment",
  UPLOAD_REPORT_FILE: "Upload Report File",
  REPORT_FILE: "Report File",
  SUPPORTED_FORMATS: "Supported formats: Excel, CSV, PDF, Word",
  FILE_TOO_LARGE: "File is too large. Maximum size is 10MB.",
  FILE_REQUIRED: "Please select a report file",
  REPORT_UPLOADED_SUCCESSFULLY: "Weekly Report Uploaded Successfully",
  DOWNLOAD_REPORTS_ZIP: "Download Reports as ZIP",
  SELECT_DATE_RANGE: "Select Date Range",
  DOWNLOAD_STARTED: "Download Started...",
  DOWNLOAD_COMPLETED: "Download Completed",
  CONFIRM_CREATE_TITLE: "Create Weekly Report",
  CONFIRM_CREATE_TEXT: "Are you sure you want to create a weekly report?",
  CASH_REGISTER_READINGS: "Cash Register Readings",
  SALES_ORDERS: "Sales Invoices",
  SALES_INVOICES: "Sales Invoices",
  DATE_RANGE: "Date Range",
  NO_CASH_REGISTER_READINGS: "No cash register readings for this period",
  NO_SALES_ORDERS: "No sales invoices for this period",
  DAILY_SALES: "Details",
  DAILY_SALES_SUMMARY: "Daily Sales Summary",
  WEEK_OF: "Week of",
  NO_SALES_DATA: "No sales data for this period",
  TOTAL_SALES: "Total Sales",
  TOTAL_SALES_ORDERS: "Total Sales Invoices",
  VENDING_MACHINE_SALES: "Vending Machine Sales",
  VENDING_MACHINE_SALES_AMOUNT: "Sales Amount",
  VENDING_MACHINE_SALES_HELP: "Enter the total vending machine sales for this week",
  VENDING_MACHINE_SALES_UPDATED: "Vending Machine Sales Updated Successfully",
  UPDATE_VENDING_MACHINE_SALES: "Update Vending Machine Sales",
  ACTUAL_RECEIVED_TOTAL: "Actual amount received",
  COUPONS_TO_INVOICE_TOTAL: "Coupons to invoice (week)",
  COUPONS_TO_INVOICE_REMAINING: "Remaining to invoice (coupons, cumulative)",
  CASH_REGISTERS_SALES: "Cash Register Sales",
  INVOICING_SALES: "Invoicing",
  SUBSIDIZED_SALES: "Food Aid",
  TOTAL_PURCHASES_ORDERS: "Total Purchase Invoices",
  PURCHASES_ORDERS: "Purchase Invoices",
  PURCHASES_INVOICES: "Purchase Invoices",
  NO_PURCHASES_ORDERS: "No purchase invoices for this period",
  ADD_NEW_LINE: "Add New Line",
  PURCHASE_SUMMARY: "Purchase Summary",
  PURCHASE_TYPE: "Purchase Type",
  REGULAR_PURCHASES: "Regular Purchases",
  ADDITIONAL_PURCHASES: "Additional Purchases",
  TOTAL_PURCHASES: "Total Purchases",
  NET_PROFIT: "Net Profit",
  SALES_ORDERS: "Sales Invoices",
  CASH_REGISTER_SUMMARY: "Cash Register Summary",
  TOTAL_SALES_ORDERS: "Total Sales Invoices",
  ADD_NEW_SALES_LINE: "Add New Invoice Line",
  SALES_ORDERS_TOTAL: "Total Sales",
  PURCHASE_ORDERS_TOTAL: "Total Purchase Invoices",
  TRANSFER_IN: "Transfers In",
  TRANSFER_OUT: "Transfers Out",
  TRANSFER_IN_WITH_TAXES: "Transfers In (with taxes)",
  TRANSFER_OUT_WITH_TAXES: "Transfers Out (with taxes)",
  INTERNAL_INVOICE_IN: "Internal invoices in",
  INTERNAL_INVOICE_OUT: "Internal invoices out",
  INTERNAL_INVOICE_IN_WITH_TAXES: "Internal invoices in (with taxes)",
  INTERNAL_INVOICE_OUT_WITH_TAXES: "Internal invoices out (with taxes)",
  NO_TRANSFERS: "No transfers for this period",
  NO_INTERNAL_INVOICES: "No internal invoices for this period",
  PURCHASES: "Purchases",
  PURCHASES_CONSUMABLES: "Food Purchases",
  OTHER: "Total Costs",
  EXCERPT: "Manager Comments",
  TOTAL_COSTS: "Total Costs",

  // Calculation sources (tooltips)
  CALCULATION_SOURCE: "Calculation source",
  SRC_DAILY_SALES:
    "Sum of the week's cash register readings (Z). The \"Without taxes\" column removes GST + QST for universities and colleges.",
  SRC_ACTUAL_RECEIVED:
    "Sum of the week's cash register readings \"Actual amount received\" (cash-in − coupons), plus coupons invoiced during the week (untaxed subtotal of validated or paid coupon invoices).",
  SRC_COUPONS_TOTAL:
    "Sum of the \"Coupon (To invoice)\" amounts entered in the week's cash register readings.",
  SRC_COUPONS_REMAINING:
    "Cumulative coupons entered in cash register readings since the beginning − cumulative validated or paid coupon invoices, as of the end of the week.",
  SRC_INVOICING_SALES:
    "Subtotal of validated or paid sales invoices whose invoicing date falls in the week, plus extra sales lines. Coupon invoices are excluded: their amount is already counted in cash register sales.",
  SRC_INTERNAL_INVOICE_OUT:
    "Accepted internal invoices issued by this establishment to another establishment during the week, net of the rebate granted by the production cafeteria. Internal invoices are never taxed, so both columns show the same amount.",
  SRC_VENDING_MACHINE_SALES:
    "Manually entered amount (with taxes). The untaxed value is derived for universities and colleges.",
  FORMULA_TOTAL_SALES:
    "Cash register sales {daily} + Invoicing {invoicing} + Internal invoices out {internal} + Vending machines {vending} = {total}",
  SRC_PURCHASE_ORDERS_TOTAL:
    "Subtotal of validated or paid purchase invoices whose invoicing date falls in the week, plus extra purchase lines.",
  SRC_TRANSFER_OUT:
    "Accepted transfers sent by this establishment during the week (removed from purchases).",
  SRC_TRANSFER_IN:
    "Accepted transfers received by this establishment during the week (added to purchases).",
  SRC_INTERNAL_INVOICE_IN:
    "Accepted internal invoices received from another establishment during the week, net of the rebate granted by the production cafeteria (added to purchases). Internal invoices are never taxed, so both columns show the same amount.",
  FORMULA_TOTAL_PURCHASES:
    "Purchase invoices {regular} + Transfers in {transferIn} − Transfers out {transferOut} + Internal invoices in {internalIn} = {total}",
  SRC_CONSUMABLES_PURCHASES:
    "Lines of purchase invoices, internal invoices in and transfers in whose product category is \"comestible\", minus comestible transfers out (without taxes).",
  SRC_WAGES: "Entered amount. With taxes = wages × 1.22 (22% payroll charges).",
  SRC_RENT:
    "Entered or computed amount depending on the establishment rent type (fixed amount or royalty). No tax applied.",
  FORMULA_TOTAL_COSTS: "Wages {wages} + Rent {rent} = {total}",
  FORMULA_NET_PROFIT:
    "Total sales {sales} − Total purchases {purchases} − Total costs {costs} = {total}",
  FORMULA_RATIO: "{label} {numerator} / Total sales {sales} = {ratio}",
  SRC_TARGET: "Target defined on the establishment.",
  SRC_DIFFERENCE: "Result − Target.",
  SRC_NET_PROFIT_DIFFERENCE: "Net profit − Target.",
  COUPON_INVOICE_EXCLUDED:
    "Coupon invoice: excluded from total sales, its amount is already counted in cash register sales. It moves \"Remaining to invoice\" into \"Actual amount received\".",
  COUPON_INVOICE_BADGE: "Coupons (excluded from sales)",
  FILTER_BY_ESTABLISHMENT: "Filter by establishment",
  FILTER_BY_DATES: "Filter by dates",
  
  // Target Ratio Analysis
  TARGET_RATIO_ANALYSIS: "Target Ratio Analysis",
  WAGES_RATIO: "Wages Ratio",
  PURCHASES_RATIO: "Purchases Ratio", 
  NET_PROFIT_RATIO: "Net Profit Ratio",
  TARGET: "Target",
  ACTUAL: "Actual",
  DIFFERENCE: "Difference",
  TARGET_REACHED: "Target Reached",
  ABOVE_TARGET: "Above Target",
  BELOW_TARGET: "Below Target",
  UNDER_TARGET: "Under Target",
  OVER_TARGET: "Over Target",
  PURCHASE_TOTAL: "Purchase Total",
  REFRESH_CALCULATIONS: "Refresh Calculations",
  CALCULATIONS_REFRESHED: "Calculations refreshed successfully",
  RESULT: "Result",
  SAVING: "Saving",
  UNSAVED_CHANGES: "Unsaved changes",
  CONSUMABLES_PURCHASES_TOTAL: "Total Food Purchases",

  // Validation
  VALIDATE_REPORT: "Validate Report",
  REVERT_TO_DRAFT: "Revert to Draft",
  WEEKLY_REPORT_VALIDATED: "Weekly Report Validated Successfully",
  WEEKLY_REPORT_REVERTED: "Weekly Report Reverted to Draft",
  VALIDATE_WARNING_TITLE: "Warning — Open Items",
  OPEN_ITEMS_WARNING: "There are still open items for this period:",
  OPEN_SALES_ORDERS_COUNT: "{count} open sales order(s)",
  OPEN_SALES_INVOICES_COUNT: "{count} open sales invoice(s)",
  OPEN_PURCHASES_ORDERS_COUNT: "{count} open purchase order(s)",
  OPEN_PURCHASES_INVOICES_COUNT: "{count} open purchase invoice(s)",
  OPEN_TRANSFERS_COUNT: "{count} open transfer(s)",
  OPEN_INTERNAL_INVOICES_COUNT: "{count} open internal invoice(s)",
  OPEN_CASH_REGISTER_READINGS_COUNT: "{count} open cash register reading(s)",
  RECOMMEND_CLOSE_ITEMS: "It is recommended to close these items before validating the report.",
  VALIDATE_ANYWAY: "Validate Anyway",
  VALIDATE_BLOCKED_TITLE: "Cannot validate — wages missing",
  WAGES_REQUIRED:
    "Wages for this week are $0. Enter them in the « Details » tab: the report cannot be validated without wages.",
  CONFIRM_VALIDATE_TITLE: "Validate Weekly Report",
  CONFIRM_VALIDATE_TEXT: "Are you sure you want to validate this report? Once validated, it cannot be modified.",
  CONFIRM_REVERT_TITLE: "Revert to Draft",
  CONFIRM_REVERT_TEXT: "Are you sure you want to revert this report to draft? It will become editable again.",
  REPORT_VALIDATED: "Validated",
  REPORT_DRAFT: "Draft",
  INTERNAL_INVOICE_PRODUCTS_RECEIVED: "Products invoiced internally — received",
  INTERNAL_INVOICE_PRODUCTS_SENT: "Products invoiced internally — sent",
  INTERNAL_INVOICE_PRODUCTS_HELP: "Only products that actually went through an accepted internal invoice. An ordered but never received product does not show up. Amounts are net of the rebate granted by the production cafeteria, like the report totals.",
  INVOICES_COUNT: "Invoices",
};
